var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "strike-price-schedule",
      attrs: { "data-testid": "strike-price-schedule-editor" }
    },
    [
      _c(
        "p",
        {
          staticClass: "help-block m-b-10",
          attrs: { "data-testid": "strike-price-timezone-label" }
        },
        [_vm._v("\n    " + _vm._s(_vm.timezoneLabel) + "\n  ")]
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("div", { staticClass: "m-b-10" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-sm",
                attrs: {
                  type: "button",
                  disabled: _vm.isEmpty,
                  "data-testid": "strike-price-clear-all"
                },
                on: { click: _vm.clearAll }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("STRIKE_PRICE_CLEAR_ALL")) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("StrikePriceGrid", {
        attrs: { matrix: _vm.matrix, editable: !_vm.isReadOnly },
        on: { "matrix-updated": _vm.onMatrixUpdated }
      }),
      _vm._v(" "),
      _vm.isEmpty
        ? _c(
            "p",
            {
              staticClass: "help-block m-t-5",
              attrs: { "data-testid": "strike-price-grid-empty" }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("STRIKE_PRICE_GRID_EMPTY")) + "\n  "
              )
            ]
          )
        : !_vm.isReadOnly
        ? _c(
            "div",
            {
              staticClass: "help-block m-t-5",
              attrs: { "data-testid": "strike-price-how-to" }
            },
            [
              _c("p", { staticClass: "m-b-0" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("STRIKE_PRICE_HOW_TO_TITLE")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "m-b-0 p-l-25" }, [
                _c("li", [_vm._v(_vm._s(_vm.$t("STRIKE_PRICE_HOW_TO_FILL")))]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("STRIKE_PRICE_HOW_TO_DELETE")))
                ]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.$t("STRIKE_PRICE_HOW_TO_COPY")))])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }